var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view == 'sinc-pedido-entrantes')?_c('view-component',{attrs:{"change_from_dates_option":"","model_name":"sync_from_meli_order"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }